import { createStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() =>
  createStyles({
    paper: {
      width: '200px',
      backgroundColor: 'transparent',
    },
    outerGrid: {
      backgroundColor: '#383838',
      borderRadius: 8,
      marginTop: 10,
    },
    sortElement: {
      backgroundColor: 'rgba(42, 171, 63, 0.08)',
    },
    fullWidth: {
      minWidth: '100%',
    },
    textStyle: {
      width: '100%',
      lineHeight: '20px',
      letterSpacing: '0.5px',
      textAlign: 'start',
    },
    textStyleBg1: {
      color: 'rgba(42, 171, 63, 1)',
    },
    textStyleBg2: {
      color: 'rgba(255, 255, 255, 0.87)',
    },
    iconStyle: {
      lineHeight: '20px',
      letterSpacing: '0.5px',
      color: 'rgba(255, 255, 255, 0.87)',
      textAlign: 'end',
    },
  }),
);
export default useStyles;
